import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetFacturaInfo } from '../../shared/interfaces/database/liquidacion';

@Injectable({
  providedIn: 'root'
})
export class FacturaService {

  private readonly baseUrl = `${environment.apiUrl}/api/factura`;

  constructor(private http: HttpClient) { }

  getFacturaInfo(tramRegistroId: number): Observable<IGetFacturaInfo> {
    return this.http.get<IGetFacturaInfo>(`${this.baseUrl}/facturas-info/${tramRegistroId}`);
  }

}
